"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubStageBarChart = void 0;
var react_1 = __importDefault(require("react"));
var react_apexcharts_1 = __importDefault(require("react-apexcharts"));
/**
 * Stacked bar chart showing the number of use cases in each stage.
 *
 * @param {WsAiHubStageBarChartProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubStageBarChart = function (props) {
    var countTotal = props.stage1 +
        props.stage2 +
        props.stage3 +
        props.stage4 +
        props.stage5 +
        props.stage6 +
        props.stage7;
    var options = {
        legend: {
            show: props.legendVisible,
            position: "top",
            horizontalAlign: "left",
            offsetX: 40,
            fontSize: "16px",
        },
        colors: [
            "#888888",
            "#671E75",
            "#E57200",
            "#B19F16",
            "#007096",
            "#0018A8",
            "#00A82D",
        ],
        chart: {
            type: "bar",
            stacked: true,
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            style: {
                fontSize: "16px",
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
            },
        },
        stroke: {
            width: 1,
            colors: ["#fff"],
        },
        xaxis: {
            categories: [""],
            min: 0,
            max: countTotal > 0 ? countTotal : 100,
            tickAmount: 5,
        },
        yaxis: {
            title: {
                text: undefined,
            },
            axisTicks: {
                show: false,
            },
        },
        fill: {
            opacity: 1,
        },
    };
    var series = [
        {
            name: "Backlog",
            data: [props.stage1],
        },
        {
            name: "Qualification",
            data: [props.stage2],
        },
        {
            name: "Prioritisation",
            data: [props.stage3],
        },
        {
            name: "Definition",
            data: [props.stage4],
        },
        {
            name: "Readiness",
            data: [props.stage5],
        },
        {
            name: "Implementation",
            data: [props.stage6],
        },
        {
            name: "Complete",
            data: [props.stage7],
        },
    ];
    return (react_1.default.createElement(react_apexcharts_1.default, { series: series, options: options, type: "bar", height: 145 }));
};
exports.WsAiHubStageBarChart = WsAiHubStageBarChart;
